import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useToolStore } from '../../store/useToolStore';
import { Sparkles, Crown, LogOut, PanelRightOpen } from 'lucide-react';
import { LanguageSwitcher } from '../LanguageSwitcher';

const Header: React.FC = () => {
    const { profile, signOut, credits, isPro } = useAuth();
    const { isPanelOpen, togglePanel } = useToolStore();

    return (
        <header className="h-12 bg-black border-b border-zinc-800 flex items-center justify-between px-6 z-20 shrink-0 select-none">
            <div className="flex items-center gap-3">
                <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-indigo-500 shadow-[0_0_8px_rgba(99,102,241,0.6)]"></div>
                    <span className="text-zinc-100 font-bold tracking-[0.2em] uppercase text-xs">Dotting</span>
                </div>
                <div className="h-4 w-px bg-zinc-800"></div>
                <span className="text-zinc-600 text-[10px] font-mono tracking-wide">AI ARCHITECTURAL SUITE</span>
            </div>

            <div className="flex items-center gap-6">
                {/* Plan Badge */}
                {isPro && (
                    <div className="flex items-center gap-1.5 px-2 py-0.5 rounded border border-yellow-900/30 bg-yellow-900/10">
                        <Crown size={10} className="text-yellow-500" />
                        <span className="text-[10px] text-yellow-500 font-bold tracking-wider uppercase">Pro</span>
                    </div>
                )}

                {/* Credits Counter */}
                <div className="flex items-center gap-2 bg-zinc-900 rounded-full px-3 py-1 border border-zinc-800 group hover:border-zinc-700 transition-colors cursor-help" title="Available Generation Credits">
                    <Sparkles className="w-3 h-3 text-emerald-400 group-hover:text-emerald-300 transition-colors" />
                    <span className="text-zinc-300 text-xs font-medium tabular-nums">{credits} <span className="text-zinc-600 ml-1">Credits</span></span>
                </div>

                {/* Language Switcher Button (Custom styled for header) */}
                <LanguageSwitcher />

                {/* User Avatar Placeholder */}
                <div className="w-6 h-6 rounded-full bg-zinc-800 border border-zinc-700 flex items-center justify-center text-xs text-zinc-400 font-medium select-none">
                    {profile?.full_name?.[0] || 'U'}
                </div>

                {/* Logout Button */}
                <button
                    onClick={signOut}
                    className="p-1.5 rounded-md text-zinc-500 hover:text-red-400 hover:bg-red-950/30 transition-colors"
                    title="Sign Out"
                >
                    <LogOut size={14} />
                </button>

                <div className="h-4 w-px bg-zinc-800 mx-2"></div>

                {/* Panel Toggle */}
                <button
                    onClick={togglePanel}
                    className={`p-2 rounded-md transition-all ${isPanelOpen ? 'bg-zinc-800 text-white' : 'text-zinc-500 hover:text-white'}`}
                    title={isPanelOpen ? "Close Panel" : "Open Panel"}
                >
                    <PanelRightOpen size={18} />
                </button>
            </div>
        </header>
    );
};

export default Header;
